import React from 'react';
import { ReactComponent as ChatWithUsIcon } from "../../static/images/chatWithUsIcon.svg";
import { ReactComponent as ChatWithUsIconMobile } from "../../static/images/chatWithUsIconMobile.svg";

import { Container } from './style';

export const ChatTrigger = ({ isMobile = false, tracker }) => {
    const onClick = () => {
        tracker();
        window.Chatra && window.Chatra('openChat', true);
    }

    return (
        <Container
            onClick={onClick}
        >
            {isMobile ? <ChatWithUsIconMobile /> : <ChatWithUsIcon />}
        </Container>
    )
}